<template>
  <div class="home">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <!-- fixed -->
        <van-nav-bar
          :title="$t('platform.editPlatform')"
          left-arrow
          z-index="9"
          @click-left="$router.push('/PlatformInfo')"
        >
          <van-icon
            name="./static/img/Trash.png"
            slot="right"
            style="font-size: 24px"
            @click="delPlatform()"
          />
        </van-nav-bar>
      </div>
    </div>
    <div class="shopList ninew bodybox">
      <van-cell-group style="margin-bottom: 7px">
        <van-field
          v-model="platformInfo.name"
          :label="$t('platform.platname')"
          clearable
          :placeholder="$t('platform.inputPlatName')"
        />
        <!-- 店铺图片 -->
        <van-cell
          :title="$t('platform.platImage')"
          title-style="width: 125px;flex:none;"
        >
          <van-uploader name="image" :after-read="afterRead">
            <van-image v-if="image" width="55" height="55" :src="image" />
            <van-image
              v-else
              width="55"
              height="55"
              fit="contain"
              src="./static/img/add_img.png"
            />
          </van-uploader>
        </van-cell>
        <!-- 二维码图 -->
        <van-cell
          :title="$t('platform.platCode')"
          title-style="width: 125px;flex:none;"
        >
          <van-image width="55" height="55" :src="qrcode" />
          <!-- <van-uploader name="qrcode" :after-read="afterRead">
            <van-image v-if="qrcode" width="55" height="55" :src="qrcode" />
            <van-image
              v-else
              width="55"
              height="55"
              fit="contain"
              src="./static/img/add_img.png"
            />
          </van-uploader> -->
        </van-cell>
        <van-cell
          :title="$t('platform.platLink')"
          title-style="width: 125px;flex:none;"
        >
          <div>{{ platformInfo.link }}</div>
        </van-cell>
        <!-- <van-field
          v-model="platformInfo.link"
          :label="$t('platform.platLink')"
          clearable
          :placeholder="$t('platform.platInputLink')"
        /> -->
      </van-cell-group>

      <van-grid :column-num="3" gutter="10" clickable style="padding: 0">
        <van-grid-item
          v-for="(shop, index) in shopList"
          :key="index"
          @click="goShop(shop.link)"
          :style="(index + 1) % 3 == 0 ? 'padding-right:0' : ''"
        >
          <div class="shopBj">
            <van-image
              v-if="shop.image"
              class="shopIcon"
              round
              width="80"
              height="80"
              :src="shop.image"
            />
            <van-image
              v-else
              class="shopIcon"
              round
              width="80"
              height="80"
              src="./static/img/boss_shop_s.png"
            />
          </div>
          <div class="shopname1">
            <p class="shopname">{{ shop.name }}</p>
          </div>
        </van-grid-item>
      </van-grid>
    </div>

    <!-- 提交按钮 -->
    <div class="btnwrap bodybox ninew">
      <van-button
        class="issueBtn"
        round
        type="default"
        style="font-weight: bold; font-size: 16px"
        @click="editPlatform()"
        >{{ $t("EditStaff.submit") }}</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopList: [],
      image: "",
      qrcode: "",
      platformInfo: {
        name: "",
        // image: "",
        // qrcode: "",
        link: "",
      },
    };
  },
  mounted: function () {
    this.getPlatform();
  },
  methods: {
    getPlatform() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/platform/" + this.$route.params.id + "/show",
      })
        .then((res) => {
          console.log(res.data.data);
          if (res.data.status == 200) {
            console.log("1111");
            // this.shopList = res.data.associations;
            this.image = res.data.data.image.path;
            this.qrcode = res.data.data.qrcode.path;
            this.platformInfo.name = res.data.data.name;
            // this.image = res.data.data.image;
            // this.qrcode = res.data.data.qrcode;
            this.platformInfo.link = res.data.data.link;
            console.log(this.platformInfo, "平台資料");
          } else {
            console.log("else");
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
    afterRead(file, detail) {
      // 此时可以自行将文件上传至服务器
      // console.log(file);
      // console.log(detail.name);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token,
        },
        data: formData,
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            if (detail.name == "qrcode") {
              this.platformInfo.qrcode_id = res.data.success.image_id;
              this.qrcode = res.data.success.url;
            } else if (detail.name == "image") {
              this.platformInfo.image_id = res.data.success.image_id;
              this.image = res.data.success.url;
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message"),
          });
        });
    },
    // 编辑平台资料
    editPlatform() {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/platform/" + this.$route.params.id + "/update",
        data: this.platformInfo,
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message,
            });
            const vm = this;
            setTimeout(function () {
              vm.$router.push("/PlatformInfo");
            }, 1000);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
    // 刪除資料
    delPlatform() {
      this.$dialog
        .confirm({
          title: this.$t("platform.deleteP"),
          message: this.$t("platform.isDeleteP"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel"),
        })
        .then(() => {
          this.$axios({
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + sessionStorage.token,
            },
            url:
              this.$build +
              "/api/platform/" +
              this.$route.params.id +
              "/destroy",
          })
            .then((res) => {
              console.log(res);
              if (res.data.status == 200) {
                this.$toast({
                  type: "success",
                  message: res.data.message,
                });
                const vm = this;
                setTimeout(function () {
                  vm.$router.push("/PlatformInfo");
                }, 1000);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item],
                  });
                }
              }
            })
            .catch((err) => {
              this.$toast({
                type: "fail",
                message: this.$t("ShopList.message"),
              });
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goShop(link) {
      if (link) {
        window.open(link);
      }
    },
  },
};
</script>
<style>
.addShop .van-grid-item__content {
  padding: 0;
}
.addShop .van-image {
  margin: auto;
}
</style>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 26px;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
}
.home {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}
.shopList {
  /* padding-top: 53px; */
  padding-top: 20px;
}

/deep/ .van-grid-item__content p {
  font-size: 12px;
  text-align: center;
  margin: 0;
  padding: 0;
}
/deep/ .van-grid-item__content {
  padding: 0;
  border-radius: 5px;
  padding-bottom: 10px;
  align-items: center;
  -webkit-align-items: center;
  justify-content: flex-start;
}
.van-grid-item__content p.shopname {
  font-size: 15px;
}
.shopname1 {
  height: 36px;
  align-items: center;
  display: inline-flex;
}
.shopname {
  line-height: 18px;
  align-items: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shoptime {
  font-size: 12px;
  color: #d4d4d4;
}
.shoptime span {
  color: rgb(253, 63, 63);
}
.van-image {
  align-items: center;
  -webkit-align-items: center;
}
.van-image__img {
  vertical-align: middle;
}
.shopBj {
  width: 100%;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
.shopIcon {
  margin: 10px 0;
}

.btnwrap {
  /* position: fixed;
  bottom: 0; */
  width: 95%;
  margin: 0 auto;
  margin-top: 20px;
  height: 60px;
  /* background: #fff; */
  /* border: 1px solid red; */
}
.issueBtn {
  width: 100%;
  /* position: absolute;
  left: 50%;
  top: 50%; */
  color: #fff;
  /* transform: translate(-50%, -50%); */
  background: #000;
}
</style>



// WEBPACK FOOTER //
// src/Platform/PlatformInfoEdit.vue